import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import sha256 from 'crypto-js/sha256';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useTranslation } from 'react-i18next';

function Videos({ dragHandleProps }) {

    const { t } = useTranslation();

    const apiUrl = process.env.REACT_APP_BACKEND_URL
    const ImageUrl = process.env.REACT_APP_IMAGES_URL

    let userId = Cookies.get('userId');
    let UserToken = Cookies.get('UserSpecialToken');
    let LanguageSelected = Cookies.get('LanguageSelected');

    const hashedUserId = sha256((String(userId)));

    const [VideoModal, setVideoModal] = useState(false)
    const [VideosInfo, setVideosInfo] = useState({
        description: { fr: '', en: '', ar: '' },
       
    })
    const [Done, setDone] = useState(false)
    const [InputsErrors, setInputsErrors] = useState([])
    const [VideoId, setVideoId] = useState()
    const [VideosContent, setVideosContent] = useState([])
    const [EditVideoModal, setEditVideoModal] = useState(false)
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        if (VideoModal || EditVideoModal) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
    }, [VideoModal, EditVideoModal]);


    const [currentIndex, setCurrentIndex] = useState(0); // Initialize currentIndex with 0

    const goToPrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : VideosContent.length - 1));
    };

    const goToNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex < VideosContent.length - 1 ? prevIndex + 1 : 0));
    };
    const AddingVideoInfo = (e) => {
        const { name, value } = e.target;
        if (name.includes('-')) {
            const [field, lang] = name.split('-');
            setVideosInfo(prev => ({
                ...prev,
                [field]: {
                    ...prev[field],
                    [lang]: value
                }
            }));
        } else {
            setVideosInfo(prev => ({ ...prev, [name]: value }));
        }
    }
    const SetVideosToUpdateDefaultValues = (id) => {
        const video = VideosContent.find(video => video.id === id);
         let fullURL = '';
    if (video.Platform === 'Youtube') {
        fullURL = `https://www.youtube.com/watch?v=${video.URL}`;
    } else if (video.Platform === 'Viemo') {
        fullURL = `https://vimeo.com/${video.URL}`;
    } else {
        fullURL = video.URL; // Fallback to original if unknown platform
    }
        return setVideosInfo({
            ...VideosInfo,
             Video_id: id,
            Platform: video?.Platform || '',
            URL: fullURL || '',
            description: video?.description || { fr: '', en: '', ar: '' }
        });
    }
    useEffect(() => {
        fetch(`${apiUrl}/GetVideosInfo`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${UserToken}`


            },
            body: JSON.stringify({ user_id: userId })


        })
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    setVideosContent(result.data)
                }
            })
    }, [Done])

    const UpdateVideoInfo = (e) => {
        setIsFetching(true);
        e.preventDefault();
        axios.post(`${apiUrl}/UpdateVideoInfo`, VideosInfo, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${UserToken}`
            },
        }).then(result => {
            if (result.data.success) {
                setVideosInfo({
                    description: { fr: '', en: '', ar: '' }
                });
                setInputsErrors([]);
                setDone(!Done);
                setEditVideoModal(false);
                toast.success(result.data.message, {
                    position: toast.POSITION.CENTER
                });
            } else {
                setInputsErrors(result.data.errors);
            }
        }).finally(() => {
            setIsFetching(false);
        });

    }
    const StoreVideoInfo = (e) => {
        setIsFetching(true);
        e.preventDefault();

        axios.post(`${apiUrl}/StoreVideoInfo`, VideosInfo, {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${UserToken}`
            }
        }).then(result => {
            if (result.data.success) {
                setVideosInfo({
                    description: { fr: '', en: '', ar: '' }
                });
                setDone(!Done);
                setInputsErrors([]);
                setVideoModal(false);
                toast.success(result.data.message, {
                    position: toast.POSITION.CENTER
                });
            } else {
                setInputsErrors(result.data.errors);
            }
        }).finally(() => {
            setIsFetching(false)
        });

    }

    const DeleteVideoInfo = (e, id,lang) => {
        e.preventDefault()

        fetch(`${apiUrl}/DeleteVideoInfo`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${UserToken}`


            },
            body: JSON.stringify({ VideoId: id, lang: lang  })
        })
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    setDone(!Done)
                    toast.success(result.message, {
                        position: toast.POSITION.CENTER
                    });
                }
            })
    }



    return (
        <div className={`${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>

            <section className="info  m-3">
                <div className="rounded-xl p-3  sections pb-5">
                    <div className="pb-2 ">
                        <h1 className={`${LanguageSelected == 'ar' ? 'title title--h1 first-title title__separate text-theme right-2' : 'title left-0 title--h1 first-title title__separate text-theme'}`}>{t("Vidéos")}</h1>
                    </div>
                    <div className="pb-0">

                        <div className="grid grid-cols-1 js-masonry   js-filter-container">
                            <div className="gutter-sizer " />
                            {/* Item 1 */}
                            {
                                VideosContent && VideosContent.length > 0 &&

                                <>

                                    <div className="relative col-12">

                                        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 z-50 flex gap-2">

                                            {VideosContent.map((_, i) => (
                                                <span
                                                    key={i}
                                                    className={`block h-1  cursor-pointer rounded-2xl transition-all content-[''] ${currentIndex === i ? "bg-gray-300 w-8" : "bg-gray-300 w-4"
                                                        }`}
                                                    onClick={() => setCurrentIndex(i)}
                                                />
                                            ))}

                                        </div>
                                        <div className="carousel-container relative">
                                            <div className="carousel-wrapper">
                                                {VideosContent.map((video, index) => {
                                                    const currentDesc = video.description?.[LanguageSelected] || '';
                                                    const isEmpty = !currentDesc.trim();

                                                    return (
                                                        <div
                                                            key={index}
                                                            className={` category-concept pl-3 pr-3 ${currentIndex === index ? "" : "hidden"}`}>
                                                            {isEmpty ?
                                                                (
                                                                    <div className="w-full p-3 flex flex-col items-center justify-center">
                                                                        <div className="w-full h-48 flex justify-center items-center rounded-lg mb-2 bg-gray-700">
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                fill="none"
                                                                                viewBox="0 0 24 24"
                                                                                strokeWidth="1.5"
                                                                                stroke="currentColor"
                                                                                className="w-16 h-16 text-gray-400"
                                                                            >
                                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z" />
                                                                            </svg>
                                                                        </div>
                                                                        <p className="text-gray-400 text-center mb-2">
                                                                            {t("No translation available for")} {LanguageSelected.toUpperCase()}
                                                                        </p>
                                                                        <button
                                                                            onClick={() => {
                                                                                setEditVideoModal(true);
                                                                                setVideoId(video.id);
                                                                                SetVideosToUpdateDefaultValues(video.id);
                                                                            }}
                                                                            className="text-gold hover:underline font-semibold"
                                                                        >
                                                                            {t("Add translation")} →
                                                                        </button>
                                                                    </div>
                                                                ) : (<>
                                                                    {
                                                                        video.Platform === 'Youtube' && (
                                                                            <div>
                                                                                <iframe
                                                                                    className='rounded-xl w-full videoclass'
                                                                                    src={`https://www.youtube.com/embed/${video.URL}`}
                                                                                    frameBorder="0"
                                                                                    allowFullScreen
                                                                                    title={`YouTube video ${video.id}`}
                                                                                />
                                                                            </div>
                                                                        )
                                                                    }
                                                                    {video.Platform === 'Viemo' && (
                                                                        <div>
                                                                            <iframe
                                                                                className='rounded-xl w-full videoclass'
                                                                                src={`https://player.vimeo.com/video/${video.URL}`}
                                                                                frameBorder="0"
                                                                                allowFullScreen
                                                                                title={`Vimeo video ${video.id}`}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                    <div className="gallery-grid__caption mt-2 mb-2">
                                                                        <span
                                                                            className={`text-about text-theme ${LanguageSelected === 'ar' ? 'text-right' : 'text-left'}`}
                                                                            dir={LanguageSelected === 'ar' ? 'rtl' : 'ltr'}
                                                                        >
                                                                            {currentDesc || video.description?.fr || video.description?.en || ''}
                                                                        </span>
                                                                    </div>

                                                                    <div className={`${LanguageSelected === 'ar' ? 'flex justify-end' : 'flex justify-end pl-5'}`}>
                                                                        <div className="flex gap-2">
                                                                            <svg
                                                                                onClick={() => {
                                                                                    setEditVideoModal(true);
                                                                                    setVideoId(video.id);
                                                                                    SetVideosToUpdateDefaultValues(video.id)
                                                                                }}
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                fill="none"
                                                                                viewBox="0 0 24 24"
                                                                                strokeWidth="1.5"
                                                                                stroke="currentColor"
                                                                                className="w-6 cursor-pointer hover:text-blue-500"
                                                                            >
                                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                                                            </svg>

                                                                            {!isEmpty && (
                                                                                
                                                                                <svg
                                                                                    onClick={(e) => { DeleteVideoInfo(e, video.id, LanguageSelected) }}
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    fill="none"
                                                                                    viewBox="0 0 24 24"
                                                                                    strokeWidth="1.5"
                                                                                    stroke="currentColor"
                                                                                    className="w-6 cursor-pointer hover:text-red-500"
                                                                                >
                                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                                                                </svg>
              
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                )}

                                                        </div>
                                                    )

                                                })}
                                            </div>
                                            {
                                                VideosContent.length > 1 &&
                                                <>
                                                    <a
                                                        className={`text-gray-300 cursor-pointer absolute -left-4 ml-0.5 next-icon-video hover:text-gray-500`}
                                                        onClick={goToPrev}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 cursor-pointer text-gray-300">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                                                        </svg>

                                                    </a>
                                                    <a
                                                        className="text-gray-300 cursor-pointer absolute  -right-4 mr-0.5  absolute next-icon-video hover:text-gray-500"
                                                        onClick={goToNext}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6 cursor-pointer text-gray-300">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                                        </svg>

                                                    </a>
                                                </>
                                            }


                                        </div>
                                    </div>
                                </>
                            }


                            <a onClick={() => { setVideoModal(true) }}>

                                <main className="flex p-3 mt-2  items-center justify-center ">
                                    <label htmlFor="dropzone-file-imagas" className="mx-auto cursor-pointer flex w-full max-w-lg flex-col items-center rounded border-2 border-dashed border-gold div-sections p-6 text-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-theme">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        <p className="mt-2 text-about tracking-wide">{t("Entrez vos Videos.")} </p>
                                    </label>
                                </main></a>

                            <div className="drag-handle flex justify-center pt-2 text-theme" {...dragHandleProps}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
                                    <path fill-rule="evenodd" d="M17.303 5.197A7.5 7.5 0 006.697 15.803a.75.75 0 01-1.061 1.061A9 9 0 1121 10.5a.75.75 0 01-1.5 0c0-1.92-.732-3.839-2.197-5.303zm-2.121 2.121a4.5 4.5 0 00-6.364 6.364.75.75 0 11-1.06 1.06A6 6 0 1118 10.5a.75.75 0 01-1.5 0c0-1.153-.44-2.303-1.318-3.182zm-3.634 1.314a.75.75 0 01.82.311l5.228 7.917a.75.75 0 01-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 01-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 01-1.247-.606l.569-9.47a.75.75 0 01.554-.68z" clip-rule="evenodd" />
                                </svg>

                            </div>
                        </div>
                    </div>

                </div>



                {
                    VideoModal &&
                    <div>

                        <div className="minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
                            <div className="absolute top-0 right-0 p-4">
                                <a className='w-12 h-12' onClick={() => { setVideoModal(false); setInputsErrors([]) }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                    </svg>
                                </a>
                            </div>
                            <div className="w-full max-w-sm   p-8 rounded-md">
                                <h2 className="text-3xl text-theme mb-2">{t("Vidéos")}</h2>
                                <form className="space-y-6 text-about">

                                    <div>
                                        <label htmlFor="email" className="textModal ">{t("Saisissez un lien vers les vidéos que vous souhaitez mettre en valeur auprès de vos rencontres.")}</label>
                                    </div>

                                    <div className="mt-3">
                                        <select name='Platform' onChange={(e) => AddingVideoInfo(e)} className="mt-5 block   px-3 py-2 bg-gray-700   rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm w-1/2  ">
                                            <option disabled selected>{t("Choisir Platform")}</option>
                                            <option value='Youtube' >Youtube</option>
                                            <option value='Viemo' >Viemo</option>
                                        </select>
                                        <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Platform') && InputsErrors.Platform}</span></p>

                                    </div>


                                    <div className="mt-3">
                                        <input onChange={(e) => { AddingVideoInfo(e) }} type="text" id="URL" name="URL" className="appearance-none block w-full placeholder-sm  px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("URL*")} required />
                                        <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('URL') && InputsErrors.URL}</span></p>

                                    </div>

                                    <div className="mt-3">
                                        {LanguageSelected === 'fr' && (
                                            <textarea
                                                value={VideosInfo.description?.fr || ''}
                                                rows={3}
                                                onChange={(e) => AddingVideoInfo(e)}
                                                name="description-fr"
                                                className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm"
                                                placeholder={t("Description")}
                                            />
                                        )}
                                        {LanguageSelected === 'en' && (
                                            <textarea
                                                value={VideosInfo.description?.en || ''}
                                                rows={3}
                                                onChange={(e) => AddingVideoInfo(e)}
                                                name="description-en"
                                                className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm"
                                                 placeholder={t("Description")}
                                            />
                                        )}
                                        {LanguageSelected === 'ar' && (
                                            <textarea
                                                value={VideosInfo.description?.ar || ''}
                                                rows={3}
                                                onChange={(e) => AddingVideoInfo(e)}
                                                name="description-ar"
                                                dir="rtl"
                                                className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm"
                                                 placeholder={t("Description")}
                                            />
                                        )}
                                        <p className="mt-2 text-red-600 dark:text-red-500">
                                            <span className="font-xsmall">{InputsErrors.hasOwnProperty('description') && InputsErrors.description}</span>
                                        </p>
                                    </div>


                                    <div>
                                        <button onClick={(e) => StoreVideoInfo(e)} disabled={isFetching} type="submit" className="w-full btn-edit">
                                            {t("enregistrer")}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                }
                {/* Edit Video Modal */}
                {EditVideoModal &&
                    VideosContent.map(video => {
                        if (video.id === VideoId) {
                            return (
                                <div key={video.id}>
                                    <div className="minscreen h-full animated fadeIn faster fixed left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info">
                                        <div className="absolute top-0 right-0 p-4">
                                            <a className='w-12 h-12' onClick={() => { setEditVideoModal(false); setInputsErrors([]) }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                                </svg>
                                            </a>
                                        </div>
                                        <div className="w-full max-w-sm p-8 rounded-md">
                                            <h2 className="text-3xl text-theme mb-2">{t("Vidéos")}</h2>
                                            <form className="space-y-6 text-about">
                                                <div>
                                                    <label className="textModal">
                                                        {t("Modifier votre vidéo")}
                                                    </label>
                                                </div>

                                                <div className="mt-3">
                                                    <select
                                                        value={VideosInfo.Platform || video.Platform}
                                                        name='Platform'
                                                        onChange={(e) => AddingVideoInfo(e)}
                                                        className="mt-5 block px-3 py-2 bg-gray-700 rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm w-1/2"
                                                    >
                                                        <option disabled>{t("Choisir Platform")}</option>
                                                        <option value='Youtube'>Youtube</option>
                                                        <option value='Viemo'>Viemo</option>
                                                    </select>
                                                    <p className="mt-2 text-red-600 dark:text-red-500">
                                                        <span className="font-xsmall">{InputsErrors.hasOwnProperty('Platform') && InputsErrors.Platform}</span>
                                                    </p>
                                                </div>

                                                <div className="mt-3">
                                                    <input
                                                        value={VideosInfo.URL || ''}
                                                        onChange={(e) => { AddingVideoInfo(e) }}
                                                        type="text"
                                                        name="URL"
                                                        className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm"
                                                        placeholder={t("URL*")}
                                                        required
                                                    />
                                                    <p className="mt-2 text-red-600 dark:text-red-500">
                                                        <span className="font-xsmall">{InputsErrors.hasOwnProperty('URL') && InputsErrors.URL}</span>
                                                    </p>
                                                </div>

                                                <div className="mt-3">
                                                    {LanguageSelected === 'fr' && (
                                                        <textarea
                                                            value={VideosInfo.description?.fr || ''}
                                                            rows={3}
                                                            onChange={(e) => AddingVideoInfo(e)}
                                                            name="description-fr"
                                                            className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm"
                                                            placeholder={t("Description")}
                                                        />
                                                    )}
                                                    {LanguageSelected === 'en' && (
                                                        <textarea
                                                            value={VideosInfo.description?.en || ''}
                                                            rows={3}
                                                            onChange={(e) => AddingVideoInfo(e)}
                                                            name="description-en"
                                                            className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm"
                                                            placeholder={t("Description")}
                                                        />
                                                    )}
                                                    {LanguageSelected === 'ar' && (
                                                        <textarea
                                                            value={VideosInfo.description?.ar || ''}
                                                            rows={3}
                                                            onChange={(e) => AddingVideoInfo(e)}
                                                            name="description-ar"
                                                            dir="rtl"
                                                            className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm"
                                                             placeholder={t("Description")}
                                                        />
                                                    )}
                                                    <p className="mt-2 text-red-600 dark:text-red-500">
                                                        <span className="font-xsmall">{InputsErrors.hasOwnProperty('description') && InputsErrors.description}</span>
                                                    </p>
                                                </div>

                                                <div>
                                                    <button
                                                        onClick={(e) => UpdateVideoInfo(e)}
                                                        disabled={isFetching}
                                                        type="submit"
                                                        className="w-full btn-edit"
                                                    >
                                                        {t("enregistrer")}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                        return null;
                    })
                }
            </section>
        </div>

    )
}

export default Videos